export async function UploadExcelApi(file, performanceCycleId) {
  try {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('performanceCycleId', performanceCycleId);

    const token = 'Bearer ' + localStorage.getItem('authToken');
    const response = await fetch(
      `${process.env.REACT_APP_API_URL}v1/bulk-plan/upload-excel`,
      {
        method: 'POST',
        headers: {
          Authorization: token,
        },
        body: formData,
      }
    );
    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Error uploading Excel file:', error);
    return { error: true, message: error.message || 'Failed to upload Excel file' };
  }
}
